import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import { WhatIsSection, WhyUseSection, ReviewSection, LegitSection, ShippingSection, CouponSection } from './components/ContentSections';
import ArticleCards from './components/ArticleCards';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const siteUrl = typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL
  ? import.meta.env.VITE_SITE_URL
  : 'https://sugargoosheet.cam';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Sheet',
  url: siteUrl + '/',
  description: 'Independent Sugargoo Spreadsheet resource platform helping international shoppers discover products, understand Sugargoo services, compare costs, and shop safely.',
  potentialAction: {
    '@type': 'SearchAction',
    target: siteUrl + '/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <article>
          <CategoryCards />
          <WhatIsSection />
          <WhyUseSection />
          <ReviewSection />
          <LegitSection />
          <ShippingSection />
          <CouponSection />
          <ArticleCards />
          <FAQSection />
        </article>
      </main>
      <Footer />
    </>
  );
}